module.exports = __webpack_public_path__ + "img/icons_38.61def19d.png";